import { SearchTerm } from './SearchTerm';

const CardTypeSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "name"
    }
];

export default CardTypeSearch;
